// HorizontalBarChart.tsx
import { Select, Spin } from "antd";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";
import { formatNumber } from "../../../services/mixin";
import { dataSelectTopReport, IDataDefaulFilter, TYPEFILTERTOP } from "../ReportCustomer";
import CustomYAxisTick from "./CustomYAxisTick";
import { formatPrice } from "../../../until";
import TooltipComponent from "../../../components/TooltipComponent";
import { useNavigate } from "react-router-dom";

interface CustomYAxisTickProps {
    x?: number;
    y?: number;
    payload?: {
        value: string;
    };
}

const MAX_CHARS_PER_LINE = 18; // chỉnh theo width 140
const MAX_LINES = 2;

const splitText = (text: string) => {
    const words = text.split(" ");
    const lines: string[] = [];
    let currentLine = "";

    for (const word of words) {
        if ((currentLine + " " + word).length <= MAX_CHARS_PER_LINE) {
            currentLine = currentLine ? `${currentLine} ${word}` : word;
        } else {
            lines.push(currentLine);
            currentLine = word;
        }
    }

    if (currentLine) lines.push(currentLine);

    return lines;
};


interface props {
    type: TYPEFILTERTOP;
    title: string;
    data: any[];
    link?: boolean
    dataFilter: IDataDefaulFilter
    color: string;
    valueTop: Record<TYPEFILTERTOP, number>
    showLoading?: boolean
    tooltipValue: string
    setValueTop: React.Dispatch<React.SetStateAction<Record<TYPEFILTERTOP, number>>>
}

export const HorizontalBarChart: React.FC<props> = ({
    type, title, dataFilter,
    data, color, valueTop, showLoading = false, link = false, tooltipValue,
    setValueTop

}) => {
    const navigate = useNavigate()


    const handleNavigate = (e: any) => {
        if (type === TYPEFILTERTOP.REGION) {
            navigate(
                `/analysis-report/customers-card-list`,
                {
                    state: {
                        firstPage: '/analysis-report/customers',
                        dataFilter,
                        provinceId: e.activePayload[0].payload.id,
                        title: `Khách hàng ở khu vực ${e.activePayload[0].payload.name}`

                    }
                }
            )
        } else {
            navigate(
                `/analysis-report/customers-card-list`,
                {
                    state: {
                        firstPage: '/analysis-report/customers',
                        dataFilter,
                        jobId: e.activePayload[0].payload.id,
                        title: `Khách hàng có nghề nghiệp ${e.activePayload[0].payload.name}`
                    }
                }
            )
        }
    }


    return (
        <div className="custom-pape-css w-full bg-white rounded-2 p-4"
            style={{ border: '1px solid #eaebec' }}
        >
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
                <div className="custom-pape-css flex gap-1 items-center ">
                    <span className="custom-page-css text-base text-344054 font-medium ">{title}</span>

                    <TooltipComponent value={tooltipValue} />
                </div>
                <Select
                    size="small"
                    bordered={false}
                    value={valueTop[type]}
                    className="custom-page-css  border rounded px-1 py-2 text-344054"
                    options={dataSelectTopReport}
                    onSelect={(e) => setValueTop(prev => ({
                        ...prev,
                        [type]: e,
                    }))}
                />
            </div>

            {/* Chart */}
            <div style={{ width: "100%", height: 500 }}>
                {showLoading ?
                    <ResponsiveContainer>
                        <BarChart
                            dataKey="KIA"
                            layout="vertical"
                            data={data}
                            onClick={(e) => {
                                link && handleNavigate(e)
                            }}
                            margin={{ left: 10, right: 20 }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis type="number" tickFormatter={(value: number) => formatPrice(value)} />
                            <YAxis
                                type="category"
                                dataKey="name"
                                width={140}
                                tick={<CustomYAxisTick />}
                            />
                            {data.length &&
                                <Tooltip
                                    labelFormatter={(label) => ` ${label}`}
                                    formatter={(value: number) => [`${formatNumber(value ?? 0)}`, 'Giá trị']}
                                />
                            }

                            <Bar
                                dataKey="value"
                                fill={color}
                                radius={[0, 6, 6, 0]}
                                barSize={valueTop[type] === 15 ? 15 : 30}
                            />
                        </BarChart>
                    </ResponsiveContainer>
                    :
                    <div
                        className='custom-page-css flex flex-col gap-2 items-center justify-center'
                        style={{ width: '100%', height: '100%' }}
                    >
                        <Spin size="default" />
                        <span>Đang tải...</span>
                    </div>
                }
            </div>
        </div>
    );
};
